
























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ExternalLinkIcon extends Vue {
  @Prop({ default: '8' }) readonly width?: string;
  @Prop({ default: '8' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
